import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import classnames from 'classnames';
import styles from './ExternalLink.css';
export const ExternalLink = memo(function ExternalLink({ to, target = '_self', title, children, className, isTextFieldLink = false, isNavLink = false, onClick, }) {
    return (_jsx("a", Object.assign({ href: to, target: target, title: title, rel: target === '_blank' ? 'noopener noreferrer' : undefined, className: classnames(className, { [styles.textFieldLink]: isTextFieldLink }, { [styles.navLink]: isNavLink }), onClick: onClick }, { children: children || to }), void 0));
});
